import { useMemo } from 'react';

// biome-ignore lint/suspicious/noExplicitAny: used on any object
export function useUrlParams(params: Record<string, any>) {
	return useMemo(() => {
		const filteredParams = Object.entries(params).reduce(
			(acc, [key, value]) => {
				if (value !== undefined && value != null && value !== '') {
					acc[key] = value;
				}
				return acc;
			},
			// biome-ignore lint/suspicious/noExplicitAny: <explanation>
			{} as Record<string, any>,
		);

		return new URLSearchParams(filteredParams).toString();
	}, [params]);
}
